import { CollisionDetection, pointerWithin } from "@dnd-kit/core"

export function getAcceptAwarePointerWithin(
  type: string | null | undefined,
  origin: string | null | undefined
) {
  const acceptAwareClosestCenter: CollisionDetection = args => {
    const collisions = pointerWithin(args)
    if (!type) {
      return collisions
    }

    const acceptedCollisions = collisions.filter(collision => {
      const dropTargetData = collision.data?.droppableContainer?.data?.current
      if (dropTargetData?.sameOrigin && dropTargetData.origin !== origin) {
        return false
      }
      const accept = dropTargetData?.accept
      return !accept || (Array.isArray(accept) && accept.includes(type))
    })

    const closest =
      acceptedCollisions.sort(
        (a, b) =>
          (a.data?.droppableContainer?.value ?? 0) -
          (b.data?.droppableContainer?.value ?? 0)
      )[0] ?? null

    return closest ? [closest] : []
  }
  return acceptAwareClosestCenter
}
